import store from '../store';
//import cookie from 'react-cookie';

import { syncUser } from '../actions';


export function onAllEnter(){
  console.log('Route Callback: onAllEnter');
  store.dispatch(syncUser());
}

export function onAppEnter(){
  console.log('Route Callback: onAppEnter');
  onAllEnter();
}



// WEBPACK FOOTER //
// ./src/routes/route_callbacks.js